/**
 * One-shot migration of legacy `app-next:*` localStorage keys to their
 * unprefixed counterparts. Must run BEFORE any Zustand store hydrates —
 * imported as a side-effect from `main.tsx` ahead of the App module.
 *
 * Idempotent: on a second pass the legacy keys are already gone, so
 * the body becomes a single-iteration no-op over an empty list.
 */

const LEGACY_PREFIX = "app-next:";

export function migrateLegacyAppNextKeys(): void {
    if (typeof window === "undefined") return;
    try {
        const ls = window.localStorage;
        const legacyKeys: string[] = [];
        for (let i = 0; i < ls.length; i += 1) {
            const k = ls.key(i);
            if (k?.startsWith(LEGACY_PREFIX)) legacyKeys.push(k);
        }
        for (const legacyKey of legacyKeys) {
            const newKey = legacyKey.slice(LEGACY_PREFIX.length);
            const legacyValue = ls.getItem(legacyKey);
            if (legacyValue === null) continue;
            if (ls.getItem(newKey) === null) {
                ls.setItem(newKey, legacyValue);
            }
            ls.removeItem(legacyKey);
        }
    } catch {
        /* SecurityError / quota — proceed silently */
    }
}

migrateLegacyAppNextKeys();
